// extracted by mini-css-extract-plugin
export var notificationHost = "_d0-0";